/**
 * @generated SignedSource<<0d6119d62b745d16f5dd17eb147119e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UrlMappingDestinationModeType = "STATIC" | "TEMPLATE" | "%future added value";
export type UrlMappingMatchType = "EXACT" | "PREFIX" | "REGEX" | "HOST_PATH" | "TRANSFORM" | "%future added value";
export type UpdateUrlMappingInput = {
  clientMutationId?: string | null;
  urlMappingId: string;
  name?: string | null;
  matchType?: UrlMappingMatchType | null;
  priority?: number | null;
  sourceUrl?: string | null;
  sourceHost?: string | null;
  sourcePath?: string | null;
  regexPattern?: string | null;
  destinationUrl?: string | null;
  destinationMode?: UrlMappingDestinationModeType | null;
  conditions?: any | null;
  active?: boolean | null;
  startsAt?: string | null;
  endsAt?: string | null;
};
export type UrlMappingEditFormContainer_Mutation$variables = {
  input: UpdateUrlMappingInput;
};
export type UrlMappingEditFormContainer_MutationVariables = UrlMappingEditFormContainer_Mutation$variables;
export type UrlMappingEditFormContainer_Mutation$data = {
  readonly updateUrlMapping: {
    readonly urlMapping: {
      readonly id: string;
      readonly name: string | null;
      readonly active: boolean;
      readonly matchType: UrlMappingMatchType;
      readonly priority: number;
      readonly sourceUrl: string | null;
      readonly sourceHost: string | null;
      readonly sourcePath: string | null;
      readonly regexPattern: string | null;
      readonly destinationUrl: string;
      readonly destinationMode: UrlMappingDestinationModeType;
      readonly conditions: any;
      readonly startsAt: string | null;
      readonly endsAt: string | null;
    } | null;
  } | null;
};
export type UrlMappingEditFormContainer_MutationResponse = UrlMappingEditFormContainer_Mutation$data;
export type UrlMappingEditFormContainer_Mutation = {
  variables: UrlMappingEditFormContainer_MutationVariables;
  response: UrlMappingEditFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUrlMappingPayload",
    "kind": "LinkedField",
    "name": "updateUrlMapping",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UrlMapping",
        "kind": "LinkedField",
        "name": "urlMapping",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "matchType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceHost",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourcePath",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "regexPattern",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "destinationUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "destinationMode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "conditions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startsAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endsAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlMappingEditFormContainer_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UrlMappingEditFormContainer_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "87dea9bf6c5d2aed32eaec8387cc2561",
    "id": null,
    "metadata": {},
    "name": "UrlMappingEditFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation UrlMappingEditFormContainer_Mutation(\n  $input: UpdateUrlMappingInput!\n) {\n  updateUrlMapping(input: $input) {\n    urlMapping {\n      id\n      name\n      active\n      matchType\n      priority\n      sourceUrl\n      sourceHost\n      sourcePath\n      regexPattern\n      destinationUrl\n      destinationMode\n      conditions\n      startsAt\n      endsAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9065a2de15b0cd9a7947a48f9fc05f3b";

export default node;
